import { Box } from "@chakra-ui/react";
import { AvailabilitySuggestedTime, BusyPeriod } from "./types";
import { timeToPosition, durationToHeight } from "./helpers";

interface CrossColumnOverlayProps {
  selectedTime: Date | undefined;
  suggestedTimes: AvailabilitySuggestedTime[];
  currentMeeting: BusyPeriod | undefined;
  durationMinutes: number;
  slotHeight: number;
  timezone: string;
}

export default function CrossColumnOverlay({
  selectedTime,
  suggestedTimes,
  currentMeeting,
  durationMinutes,
  slotHeight,
  timezone,
}: CrossColumnOverlayProps) {
  const bandHeight = durationToHeight(durationMinutes, slotHeight);

  return (
    <Box position="absolute" top={0} left={0} right={0} bottom={0} pointerEvents="none">
      {currentMeeting && (
        <Box
          position="absolute"
          top={`${timeToPosition(new Date(currentMeeting.startTime), slotHeight, timezone)}px`}
          height={`${durationToHeight(
            (new Date(currentMeeting.endTime).getTime() - new Date(currentMeeting.startTime).getTime()) / 60000,
            slotHeight,
          )}px`}
          left={0}
          right={0}
          borderWidth="1px"
          borderColor="purple.400"
          bg="purple.200"
          borderRadius="sm"
        />
      )}

      {suggestedTimes.map((st) => (
        <Box
          key={st.startTime}
          position="absolute"
          top={`${timeToPosition(new Date(st.startTime), slotHeight, timezone)}px`}
          height={`${bandHeight}px`}
          left={0}
          right={0}
          borderTopWidth="1px"
          borderBottomWidth="1px"
          borderColor="green.300"
          borderStyle="dashed"
          bg="green.50"
          opacity={0.35}
        />
      ))}

      {selectedTime && (
        <Box
          position="absolute"
          top={`${timeToPosition(selectedTime, slotHeight, timezone)}px`}
          height={`${bandHeight}px`}
          left={0}
          right={0}
          borderWidth="2px"
          borderColor="blue.400"
          bg="blue.50"
          opacity={0.45}
          borderRadius="sm"
        />
      )}
    </Box>
  );
}
